import AutocompleteComponent from './AutocompleteComponent'
export default AutocompleteComponent;